import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faPencil,
  faArrowUpRightFromSquare,
} from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import {
  AnalyticsContext,
  ViewDataHandlingEvent,
} from "../../common/context/AnalyticsContext";
import {
  AppFlowStepContainer,
  AppFlowTitle,
  AppFlowStepContentContainer,
  AppFlowContinueButton,
} from "../../common/CommonStyles";

const DataHandlingContentRow = styled.div`
  display: flex;
  gap: 1.5%;
  margin-bottom: 0.3rem;

  max-width: 460px;
`;

const DataHandlingContentImageContainer = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  max-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 0.2rem;
  margin-top: auto;
  margin-bottom: auto;

  svg {
    color: gray;
    height: 100%;
    width: 100%;
  }
`;

const DataHandlingContentText = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 0.9rem;
  }
  h6 {
    font-weight: bold;
    margin-bottom: 0.1rem;
  }
`;

export const DataHandling: React.FC<{
  next: () => void;
}> = ({ next }) => {
  const { t } = useTranslation();
  const { logEvent } = React.useContext(AnalyticsContext);
  const shouldLogViewDataHandling = React.useRef(true);

  if (shouldLogViewDataHandling.current) {
    // NOTE: This is currently fixed to `false` because that is the only version
    // of appflow that is implemented
    logEvent(new ViewDataHandlingEvent(false));
    shouldLogViewDataHandling.current = false;
  }

  return (
    <AppFlowStepContainer>
      <AppFlowTitle
        title={t("data_handling_title")}
        subtitle={t("data_handling_explanation")}
        style={{ maxWidth: "500px" }}
      />
      <AppFlowStepContentContainer
        style={{ paddingRight: "0", paddingLeft: "0" }}
      >
        <div className="flex-grow-1 d-flex flex-column justify-content-evenly align-items-center px-0">
          <DataHandlingContentRow>
            <DataHandlingContentImageContainer>
              <FontAwesomeIcon icon={faMicrophone} size="xl" />
            </DataHandlingContentImageContainer>
            <DataHandlingContentText>
              <div>
                <h6>{t("data_handling_collection_title")}</h6>
              </div>
              <div>
                <span>{t("data_handling_collection_body")}</span>
              </div>
            </DataHandlingContentText>
          </DataHandlingContentRow>
          <DataHandlingContentRow>
            <DataHandlingContentImageContainer>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xl" />
            </DataHandlingContentImageContainer>
            <DataHandlingContentText>
              <div>
                <h6>{t("data_handling_sharing_title")}</h6>
              </div>
              <div>
                <span>{t("data_handling_sharing_body")}</span>
              </div>
            </DataHandlingContentText>
          </DataHandlingContentRow>
          <DataHandlingContentRow>
            <DataHandlingContentImageContainer>
              <FontAwesomeIcon icon={faPencil} size="xl" />
            </DataHandlingContentImageContainer>
            <DataHandlingContentText>
              <div>
                <h6>{t("data_handling_usage_title")}</h6>
              </div>
              <div>
                <span>{t("data_handling_usage_body")}</span>
              </div>
            </DataHandlingContentText>
          </DataHandlingContentRow>
        </div>

        <div className="d-flex justify-content-center p-0">
          <AppFlowContinueButton
            text={t("app_flow_continue_button")}
            enabled={true}
            onClick={() => {
              next();
            }}
          />
        </div>
      </AppFlowStepContentContainer>
    </AppFlowStepContainer>
  );
};
